import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon ErrorCircleIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const ErrorCircleIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 20 20">
      <path d="M10,0C4.48,0,0,4.48,0,10s4.48,10,10,10s10-4.48,10-10S15.52,0,10,0z M10,16.67c-0.92,0-1.67-0.75-1.67-1.67 c0-0.92,0.75-1.67,1.67-1.67c0.92,0,1.67,0.75,1.67,1.67l0,0C11.67,15.92,10.92,16.67,10,16.67z M11.67,10 c0,0.92-0.75,1.67-1.67,1.67c-0.92,0-1.67-0.75-1.67-1.67c0,0,0,0,0,0V5c0-0.92,0.75-1.67,1.67-1.67c0.92,0,1.67,0.75,1.67,1.67 c0,0,0,0,0,0V10z" />
    </Icon>
  )
}
export default ErrorCircleIcon
